if (!customElements.get('dynamic-blocks')) {
  class DynamicBlocks extends HTMLElement {
    constructor() {
      super();
      this.trigger;
      this.count;
      this.DEFAULT_COUNT = 6;
    }

    connectedCallback() {
      this.count =
        Number(this.getAttribute('data-paging')) || this.DEFAULT_COUNT;
      this.trigger = this.querySelector('[dynamic-blocks="load-more"]');

      if (!this.trigger) {
        return;
      }

      this.trigger.addEventListener(
        'click',
        this.handleTriggerClick.bind(this)
      );
    }

    handleTriggerClick() {
      const items = [
        ...this.querySelectorAll('.is-hidden[dynamic-blocks="item"]'),
      ].slice(0, this.count);

      items.forEach((item) => {
        item.classList.remove('is-hidden');
      });

      if (!this.hiddenItems()) {
        this.trigger.classList.add('hidden');
      }
    }

    hiddenItems() {
      return (
        this.querySelectorAll('.is-hidden[dynamic-blocks="item"]').length > 0
      );
    }
  }

  customElements.define('dynamic-blocks', DynamicBlocks);
}
